import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const solarWinds = defineConnector({
  identifier: "solarWinds",
  name: "SolarWinds Observability",
  tagLine: "IT infrastructure monitoring",
  logo,
  protocol: "http",
  tags: ["observability", "it"],
  defaultUrlPattern: () => "https://[^/]*\\.solarwinds\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get your SolarWinds API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your SolarWinds instance and navigate to **Settings › API Credentials** to generate an API token.",
        },
      ],
    },
    {
      title: "Enter your SolarWinds details",
      items: [
        {
          kind: "url",
          label: "Instance URL",
          required: true,
          placeholder: "https://your-instance.solarwinds.com",
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "The base URL of your SolarWinds instance.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/api/v1/whoami`,
  },
  publicEnvVars: ({ baseUrl }) => ({
    SOLAR_WINDS_URL: baseUrl || "",
  }),
});
